import { createSelector } from "@reduxjs/toolkit";

// Selector to check if selectedPaylinesMin or selectedPaylinesMax has changed
export const selectPaylinesChanged = createSelector(
  (state) => state.catalog.selectedPaylinesMin,
  (state) => state.catalog.selectedPaylinesMax,
  (state) => state.catalog.paylinesMin,
  (state) => state.catalog.paylinesMax,
  (selectedPaylinesMin, selectedPaylinesMax, paylinesMin, paylinesMax) => {
    return selectedPaylinesMin !== paylinesMin || selectedPaylinesMax !== paylinesMax;
  }
);

// Selector to check if selectedMultiplierMin or selectedMultiplierMax has changed
export const selectMultiplierChanged = createSelector(
  (state) => state.catalog.selectedMultiplierMin,
  (state) => state.catalog.selectedMultiplierMax,
  (state) => state.catalog.multiplierMin,
  (state) => state.catalog.multiplierMax,
  (selectedMultiplierMin, selectedPaylinesMax, multiplierMin, multiplierMax) => {
    return selectedMultiplierMin !== multiplierMin || selectedPaylinesMax !== multiplierMax;
  }
);

export const selectSortIsChanged = createSelector(
  (state) => state.catalog.sortBy,
  (state) => state.catalog.sortDirection,
  (sortBy, sortDirection) => {
    return sortBy !== 'releaseDate' || sortDirection !== 'desc';
  }
);
